const ROUTE_PATHS = [
  '/',
  '/deliveries',
  '/schedule',
  '/training',
  '/bulletins',
  '/profile',
  '/points-shop',
  '/app',
];

function normalizeBase(base: string): string {
  const trimmed = base.trim();
  if (!trimmed) return '';
  if (trimmed === '/') return '';
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return withLeading.replace(/\/$/, '');
}

export function getBasePath(): string {
  const envBase = normalizeBase(import.meta.env.VITE_BASE_PATH || '');
  if (envBase) return envBase;

  const pathname = window.location.pathname || '/';

  // If the pathname already matches a known route, we are at root.
  if (ROUTE_PATHS.includes(pathname)) return '';

  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return '';

  // Try to detect a base path prefix so the remainder matches a known route.
  for (let i = 1; i <= segments.length; i += 1) {
    const prefix = `/${segments.slice(0, i).join('/')}`;
    const remainder = `/${segments.slice(i).join('/')}` || '/';
    const normalizedRemainder = remainder === '/' ? '/' : remainder;
    if (ROUTE_PATHS.includes(normalizedRemainder)) {
      return prefix;
    }
  }

  return '';
}

export function withBasePath(path: string): string {
  const base = getBasePath();
  if (!base) return path;
  if (path === '/') return base || '/';
  return `${base}${path}`;
}

export function stripBasePath(pathname: string): string {
  const base = getBasePath();
  if (!base) return pathname || '/';
  if (pathname === base) return '/';
  if (pathname.startsWith(`${base}/`)) {
    const stripped = pathname.slice(base.length);
    return stripped || '/';
  }
  return pathname || '/';
}
